import { Button, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import { CgDanger } from "react-icons/cg";

interface Props {
    text: string;
    actionText: string;
    actionUrl: string;
    actionFunction?: CallableFunction;
    isActionLoading: boolean;
    canGoDashboard: boolean;
}

export default function FailedSubscription({ text, canGoDashboard, actionUrl, isActionLoading, actionText, actionFunction }: Props) {
    return <div className="container my-auto py-4">
        <div className="row">
            <div className="col-11 col-lg-10 mx-auto">
                <div className="d-flex align-items-center justify-content-center">
                    <CgDanger size={50} />
                </div>

                <h3 className="text-black text-center">Ocorreu um erro</h3>
                <p className="text-center">{text}</p>

                <div className="d-flex align-items-center justify-content-center">
                    <Button onClick={actionFunction ? async (e) => {
                        e.preventDefault();
                        await actionFunction();
                    } : () => { }} href={actionUrl} style={{ borderRadius: 15, cursor: isActionLoading ? 'default' : 'pointer' }} variant="primary">{!isActionLoading ? actionText : <Spinner animation="border" size='sm'></Spinner>}</Button>
                </div>


                {
                    canGoDashboard && <p className="text-2 text-center text-black mg-t-20">
                        <span className="mx-1">
                            <Link to="/dashboard">Ir para Dashboard</Link>
                        </span>
                    </p>
                }

            </div>
        </div>
    </div>
}